export default __webpack_public_path__ + "static/media/capeb.a2893d44.png";